import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { Box } from "@mui/material";
import { RowShipType } from "@/types/view";
import { AppConstant, LangConstant } from "@/const";
import { StatusInternalRequest } from "@/components/common";
import { GridColDef } from "@/components/common/AppTable/AppTable";
import { Fragment } from "react";
import { SOURCE_TYPE } from "@/const/system.const";

const useShipSearchColumn = () => {
  const { t: getLabel } = useTranslation(LangConstant.NS_REQUEST);

  const columnList: GridColDef<RowShipType>[] = [
    {
      field: "shipName",
      headerName: getLabel("OBJ_SHIP_COL.name"),
      align: "left",
    },
    {
      field: "licensePlate",
      headerName: getLabel("OBJ_SHIP_COL.licensePlate"),
      align: "center",
    },
    {
      field: "imo",
      headerName: getLabel("OBJ_SHIP_COL.imo"),
      align: "center",
    },
    {
      field: "mmsi",
      headerName: getLabel("OBJ_SHIP_COL.mmsi"),
      align: "center",
    },
    {
      field: "created",
      headerName: getLabel("OBJ_SHIP_COL.responseAt"),
      align: "center",
      render: (cell: RowShipType) => {
        return (
          cell.created && (
            <Box>
              {dayjs(cell.created).format(AppConstant.FM_SHORT_DATE)}
              <br />
              {dayjs(cell.created).format(AppConstant.FM_FULL_HOUR)}
            </Box>
          )
        );
      },
    },
    {
      field: "source",
      headerName: getLabel("OBJ_SHIP_COL.source"),
      align: "center",
      render: (cell: RowShipType) => {
        return Object.values(SOURCE_TYPE).find(item => item.id == cell.sourceType)?.name;
      },
    },
    {
      field: "status",
      headerName: getLabel("OBJ_SHIP_COL.status"),
      align: "center",
      render: (cell: RowShipType) => (
        <Fragment>
          <StatusInternalRequest status={cell.status} />
        </Fragment>
      ),
    },
  ];

  return {
    columnList,
  };
};

export default useShipSearchColumn;
